import { getCookie } from './getCookie';
import { getKameleoonInfo } from './getKameleoonInfo';
import { getTrackingEnv } from './getTrackingEnv';
import { getUtmParams } from './getUtmParams';

export const getTrackingDefaultPayload = () => {
  const abTests = getKameleoonInfo();
  const envData = getTrackingEnv();
  const utmParams = getUtmParams();

  const userCategory = getCookie('payfit-app-user-category');
  let userType = getCookie('payfit-app-user-type');
  const payfitAppUser = getCookie('payfit-app-user') === 'true';

  if (!userType) {
    userType = payfitAppUser ? 'client' : 'lead';
  }

  const origin = window.location.origin;
  const pathname = window.location.pathname;
  const referrer = origin + pathname;

  return {
    ...envData,
    ...utmParams,
    title: document.title,
    referrer,
    abTests,
    userCategory,
    userType,
    site: 'astro',
  };
};
